import React, { useEffect } from 'react'
import MobileLayout from '../../components/MobileLayout'
import { useSearchParams } from 'react-router-dom'

import CKDFilterBookImg from '../../assets/images/filter-book.webp'
import RightArrowIcon from '../../assets/icons/right_arrow.svg'
import Text from '../../components/atoms/Text'
import { Footer } from '../Programs/CKD'
import ZydusHeader from '../../components/molecules/ZydusHeader'

const LanguageOption = ({ title, onClick }) => {
  return (
    <div
      className="flex items-center justify-between w-full p-4 mb-4 bg-white rounded-2xl shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClick}
    >
      <Text
        tag="span"
        variant="label"
        size="large"
        className="text-gray-800 font-medium"
        bold="true"
      >
        {title}
      </Text>
      <div className="w-6 h-6 flex items-center justify-center bg-background-brand-teal rounded-full">
        <img src={RightArrowIcon} alt="arrow" className="w-3 h-3" />
      </div>
    </div>
  )
}

const BooksPage = () => {
  const [searchParams] = useSearchParams()

  // Check if we should show header (only when from=CKD)
  const showHeader = searchParams.get('from') === 'CKD'

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const languages = [
    {
      name: 'English',
      code: 'en',
      url: 'https://mytatvaprodstorage.blob.core.windows.net/ckd/en.pdf',
    },
    {
      name: 'தமிழ்',
      code: 'ta',
      url: 'https://mytatvaprodstorage.blob.core.windows.net/ckd/ta.pdf',
    },
    {
      name: 'हिंदी',
      code: 'hi',
      url: 'https://mytatvaprodstorage.blob.core.windows.net/ckd/hi.pdf',
    },
    {
      name: 'తెలుగు',
      code: 'te',
      url: 'https://mytatvaprodstorage.blob.core.windows.net/ckd/te.pdf',
    },
    {
      name: 'ಕನ್ನಡ',
      code: 'kn',
      url: 'https://mytatvaprodstorage.blob.core.windows.net/ckd/kn.pdf',
    },
    {
      name: 'ગુજરાતી',
      code: 'gu',
      url: 'https://mytatvaprodstorage.blob.core.windows.net/ckd/gu.pdf',
    },
    {
      name: 'বাংলা',
      code: 'bn',
      url: 'https://mytatvaprodstorage.blob.core.windows.net/ckd/bn.pdf',
    },
    {
      name: 'मराठी',
      code: 'mr',
      url: 'https://mytatvaprodstorage.blob.core.windows.net/ckd/mr.pdf',
    },
  ]

  const handleLanguageSelect = (language) => {
    console.log('Selected language:', language)
    window.open(language.url, '_blank')
  }

  return (
    <MobileLayout>
      {showHeader && <ZydusHeader />}
      <img
        src={CKDFilterBookImg}
        className="h-[209px] w-auto lg:h-[300px] lg:mx-auto mt-20"
      />
      <div className="p-0">
        <div className="rounded-2xl p-4">
          <div className="relative ">
            {/* <img
              src={CKDBookImg}
              className="absolute top-0 -left-[16px] h-[240px] w-auto -translate-y-[39%]"
            />
            <div className="ml-[150px] mt-4 h-[103px]">
              <Text tag={'div'} variant={'title'} size="large" className={''}>
                A curated guide to nourishment and resilience
              </Text>
            </div> */}
            <div>
              <Text
                variant="label"
                size="medium"
                className={'text-text-quartenary'}
              >
                Explore kidney-friendly recipes crafted with care for CKD
                patients, and discover inspiring stories of strength and hope
                from real-life kidney warriors.
              </Text>
            </div>
            <div className="mt-4">
              <Text
                variant="label"
                size="medium"
                className={'text-text-quartenary'}
              >
                Select the language in which you want to view the book
              </Text>
            </div>
          </div>
        </div>

        {/* Language Selection Section */}
        <div className="px-4 pt-0 pb-6 lg:grid lg:grid-cols-2 lg:gap-4">
          {languages.map((language) => (
            <LanguageOption
              key={language.code}
              title={language.name}
              onClick={() => handleLanguageSelect(language)}
            />
          ))}
        </div>
      </div>
      <Footer />
    </MobileLayout>
  )
}

export default BooksPage
